import { Component, OnInit, Input } from '@angular/core';
import * as XLSX from 'xlsx';
import { APIService } from 'src/app/api.service';

type AOA = any[];
@Component({
  selector: 'app-importledger',
  templateUrl: './importledger.component.html',
  styleUrls: ['./importledger.component.scss']
})
export class ImportledgerComponent implements OnInit {

  @Input() mdlRef: any;
  constructor(private apiService: APIService) { }

  error: any = {
    showError: false,
    removeError: false,
    apiResponse: false
  };
  data: any = {}
  ladgersList : any = [];
  jarvisData: any = [];
  agencyData: any = [];

  ngOnInit(): void {
    // Jarvise
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    // AgencyData
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
  
      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws));

      console.log("Excel Data", this.data)

      this.checkitemValidation(this.data);
      // console.log("Final Data", this.data);
      if(this.ladgersList.length > 0){
          this.error.showError = true;
          this.error.removeError = false;
          $('.modal-dialog').attr('style', 'min-width: 50% !important');
          return;
      }
      else{
        this.error.showError = false;
        this.error.removeError = true;
        this.saveBulkItems()
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

   //Close Model 
   closeModal() {
    this.mdlRef.close();
  }

  //checkitemValidation() - Check import ledgers validation
  checkitemValidation(ledgers: Array<any>){
    let erroList : Array<any> = [];
    let itmArraylength = ledgers.length;
    let isCheckDup = [];
    
   //Validation
   ledgers.forEach((e: any) => {    
      e.errorMsg = ''; 

      if(!e["Ledger"]){
         e["Ledger"] = '';
      }

      if(!e["Head"]){
         e["Head"] = '';
      }

     if(!e["Opening Balance"]){
         e["Opening Balance"] = 0;
     }

     if(!e["Cr / Db"]){
       e["Cr / Db"] = '';
     }
     else{
        // e["Cr / Db"] = e["Cr / Db"].toUpperCase();       
        if((e["Cr / Db"] != 'Cr') && (e["Cr / Db"] != 'Db')){
          e["Cr / Db"] = '';
        }
     }

      if(!e["Ledger"]){
       e.errorMsg = e.errorMsg + 'Please enter the name of the ladger. '
      }
      else{
      //Ledger Duplications
         isCheckDup = $.grep(ledgers, function(o: any){ return o.Ledger == e["Ledger"]});
         if(isCheckDup.length > 1){
             e.errorMsg =  e.errorMsg + 'Duplicate ledger name in the uploaded sheet. '
         }
      }

      // Opening Balance is blank
    //  if(!e["Opening Balance"]){
    //   e.errorMsg = e.errorMsg + 'Please enter an opening balance.'
    //   e["Opening Balance"] = 0;
    // }

      // Opening Balance in nagative
     if(e["Opening Balance"] < 0){
       e.errorMsg = e.errorMsg + 'Please enter a valid opening balance. '
     }

     //Opening Balance is not a number
     if (isNaN(e["Opening Balance"])) {
        if (e.errorMsg != "") {
          e.errorMsg = e.errorMsg + " Please enter a valid opening balance."
            e["Opening Balance"] = 0;
        }
        else {
          e.errorMsg = "Please enter a valid opening balance.";
            e["Opening Balance"] = 0;
        }                           

      }

     // Group
     if(!e["Group"]){
      e.errorMsg = e.errorMsg + 'Please enter the name of the group. '
    }

      // Cr/Db
      if(!e["Cr / Db"]){
        e.errorMsg = e.errorMsg + 'Please enter Cr for Credit or Db for Debit opening balance. '
      }
      
 });

   for(let i: number = 0; i < itmArraylength; i++){
       if(ledgers[i].errorMsg != ''){
           erroList.push({
             srNo: i + 1,
             ledgerName: ledgers[i]["Ledger"],
             msg: ledgers[i].errorMsg
           });
       }
    }
    this.ladgersList = erroList;
   // console.log('ladgersList',erroList);
 }

  //saveBulkItems() - Add excel data into database
  saveBulkItems(){
    let finalItemArry:Array<any> = [];
    if(this.error.removeError == true){
      this.data.forEach(function (e: any){
        if(e.errorMsg == ''){       
            finalItemArry.push({
              'LedgerID': 0,
              'GroupID': 0,
              'GroupName': String(e["Group"]).trim(),        
              'Ledger': String(e["Ledger"]).trim(),
              'OpeningBal': e["Cr / Db"].toUpperCase()  == 'CR' ?  (-1 * e["Opening Balance"]) : e["Opening Balance"]
            });
        }
      });
    }

  //  console.log("Final Data", finalItemArry);
    
    if(finalItemArry.length == 0){
      this.apiService.successAlert("No data found.");
      this.closeModal();
      return;
    }

    let ledgerCnt = finalItemArry.length;
    
    let isAllowConfirm = confirm("Are you sure you want to import "+ ledgerCnt +" " + (ledgerCnt > 1 ? 'ledgers' : 'ledger') + " ?");
    if(!isAllowConfirm){
      return;
    }  

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");
    let data = [{
        data: JSON.stringify(finalItemArry)
    }];
debugger
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'importLedgers',
      moduleID: 2,
      data: JSON.stringify(data)
    }];

    this.apiService.sendChange(myParams, this.successItemEntry.bind(this), this.failureResp.bind(this));
  }

  //successVchrEntry - success voucher entry handler
  successItemEntry(res: any) {
    this.error.apiResponse = true;
   //  console.log("Import Item Output", res);
    if (res.error) {
    }
    else {
      this.ladgersList = [];
      let erroList: Array<any> = [];
        if (res.updatePackage) {
            let result: any = JSON.parse(res.updatePackage);
            let returnItems = result.Table1;
            if(returnItems.length > 0){
              for(let i: number = 0; i < returnItems.length; i++){
                if(returnItems[i].ErrorMsg != ''){
                    erroList.push({
                      srNo: i + 1,
                      ledgerName: returnItems[i].Ledger,
                      msg: returnItems[i].ErrorMsg
                    });
                }
              }
              this.error.showError = true;
              this.error.removeError = false;
              this.ladgersList = erroList;
              $('.modal-dialog').attr('style', 'min-width: 50% !important');
            }
            else{
              this.apiService.successAlert('Ledgers imported.');
              let doneObj = {
                action: 'Done'
              }
              this.closeModel(doneObj);
            }
          
        }
    }
 }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  closeModel(obj: any) {
    this.mdlRef.close(obj);
  }

}
